import { render, staticRenderFns } from "./tranPurReturns.vue?vue&type=template&id=c43c6374&scoped=true&"
import script from "./tranPurReturns.vue?vue&type=script&lang=js&"
export * from "./tranPurReturns.vue?vue&type=script&lang=js&"
import style0 from "./tranPurReturns.vue?vue&type=style&index=0&id=c43c6374&lang=less&scoped=true&"
import style1 from "./tranPurReturns.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43c6374",
  null
  
)

component.options.__file = "tranPurReturns.vue"
export default component.exports